import { ColorPresets } from '@/types/whiteboard';

const Color = require('color');

export type IMacroTextProp = {
  fill?: string; //文本背景色。缺失时使用白板当前的默认背景色
  fontFamily?: string; //字体。缺失时使用白板当前的默认字体
  fontSize?: number; //fontSize 限制为12-300
  color?: string; //文本颜色。缺失时使用白板当前的默认颜色
  text?: string; //文本
  strokeColor?: string; // 涂鸦（直线）、图形、或者连接的颜色
  strokeWidth?: number; // 涂鸦（直线）、连接的线段粗细。或者设置图形的边框粗细
};

export type IMacroImageProp = {
  height?: number; //宽
  width?: number; //宽
  url?: string; //图片url地址。请确保图片地址无访问限制
};

export type ToolConfig = IMacroTextProp & IMacroImageProp;

export enum ToolTye {
  LASER = 'laser', // 激光笔
  SELECT = 'select', // 选择
  PEN = 'pen', // 画笔
  PEN_MARKR = 'pen-marker', // 马克笔
  LINE_ARROW = 'line-arrow', // 箭头线
  LINE = 'line', // 直线
  RECT = 'rect', // 矩形
  ELLIPSE = 'ellipse', // 椭圆形
  TEXT = 'text', //文本
  ELEMENT_ERASER = 'element-eraser', //橡皮擦
  UNDO = 'undo', // 撤销
  REDO = 'redo', // 重做
  CLEAR = 'clear', // 清除
  DOWNLOAD = 'download', // 下载
  CLOSE = 'close', // 关闭
}

class WhiteBoardTools {
  drawPlugin: any;
  constructor(drawPlugin: any) {
    this.drawPlugin = drawPlugin;
  }
  useOftools(toolType: ToolTye, payload?: ToolConfig) {
    const { strokeColor, strokeWidth = 2, color, ...resetProps } = payload || {};
    if (toolType === ToolTye.CLOSE) {
      this.drawPlugin.setTool();
      return;
    }
    if (toolType === ToolTye.UNDO) {
      this.drawPlugin.undo();
      return;
    }
    if (toolType === ToolTye.REDO) {
      this.drawPlugin.redo();
      return;
    }
    if (toolType === ToolTye.CLEAR) {
      this.drawPlugin.clear();
      return;
    }
    if (toolType === ToolTye.DOWNLOAD) {
      return;
    }
    const options = {
      ...resetProps,
      stroke: color,
    };
    let _toolType = toolType;
    let _strokeColor = strokeColor;
    if (!_strokeColor) {
      _strokeColor = ColorPresets.RED;
    }
    if (toolType === ToolTye.PEN_MARKR) {
      _toolType = ToolTye.PEN;
      _strokeColor = Color(_strokeColor).alpha(0.5).string();
    }
    this.drawPlugin.setTool(_toolType, options);
    this.drawPlugin.setStrokeWidth(strokeWidth);
    if (_strokeColor) {
      this.drawPlugin.setColor(_strokeColor);
    }
  }
  setClor(color: string) {
    if (color) {
      this.drawPlugin.setColor(color);
    }
  }
}

export default WhiteBoardTools;
